import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import CustomTableSmall from "../../unit/CustomTableSmall";

const DashboardSearchPayment = ({ ...props }) => {
  const data: any[] | null | undefined = [];
  return (
    <CustomTableSmall
      key={"dashboardSearchPayment"}
      id="table-dashboard-search-payments"
    >
      <TableHead>
        <TableRow>
          <TableCell className="hm-table-header">App #</TableCell>
          <TableCell className="hm-table-header">Loan #</TableCell>
          <TableCell className="hm-table-header">User #</TableCell>
          <TableCell className="hm-table-header">Payment Created</TableCell>
          <TableCell className="hm-table-header">Amount</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data == undefined || data.length == 0 || data == null ? (
          <TableRow>
            <TableCell colSpan={8}>No Data </TableCell>
          </TableRow>
        ) : (
          data?.map((item: any) => (
            <TableRow key={`dashboard_search_payment_` + item.iProductId}>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </CustomTableSmall>
  );
};
export default DashboardSearchPayment;
